let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gJymL")).then(() => parcelRequire('lw4D1'));